import { TagTypes } from '../../../Api/Types/tagTypes';

export interface DeleteBookingReservationRequest {
  reservationId: number;
  bookingId: number;
}

export type BookingTag = {
  type: TagTypes.Booking;
  id: number | TagTypes.List;
};

export const buildDeleteBookingReservationRequest = (
  request: DeleteBookingReservationRequest
): { url: string; method: 'DELETE' } => ({
  url: `/reservations/${request.reservationId}`,
  method: 'DELETE',
});

export const getDeleteBookingReservationInvalidatesTags = (
  request: DeleteBookingReservationRequest
): BookingTag[] => [
  { type: TagTypes.Booking, id: request.bookingId },
  { type: TagTypes.Booking, id: TagTypes.List },
];
